import Appointment2 from '@/components/Appointment2';
import Banner from '@/components/Banner2';
import Introduction from './components/Introduction';
import Advantage from './components/Advantage';
import Cases from './components/Cases';
export default {
  components: {
    Banner,
    Introduction,
    Advantage,
    Cases,
    Appointment2
  },
  data() {
    return {
      productId: this.$productId.YUN_YING_GONG_JU.ZI_XUAN_GU_TONG_BU
    };
  }
};